import React from "react";
import styled, { css } from "styled-components";
import Container from "../../Container";
import Rule from "../../Rule";
import Links from "../../Links";
import Heading from "../../Heading";
import SkillsItem from "../Skills/SkillsItem";
import ResumeHeading from "./ResumeHeading";
import DesignSystemsProfile from "../../../img/michaeltrilford.jpeg";
import MobileBanking from "../../../img/mobile-banking.jpg";
import GuruGuidesD from "../../../img/guru-guides-default.png";
import GuruGuidesC from "../../../img/guru-guides-custom.png";
import GuruGuidesW from "../../../img/hero-guides-browser.png";
import GuruOutcomes from "../../../img/objective.png";
import Capture from "../../../img/expense-capture.jpg";
import Airwallex from "../../../img/airwallex-guidelines.png";
import AirwallexContribution from "../../../img/airwallex-contribution.png";
import Feelix from "../../../img/feelix.png";
import JourneyMap from "../../../img/casestudy/design-sprint/experience-map-exercise.jpg";
import FinalJourneyMap from "../../../img/casestudy/design-sprint/experience-map.jpg";
import Stack from "../../Stack";
import CaseStudiesCard from "../CaseStudies/CaseStudiesCard";
import Box from "../../Box";
import Image from "../../Image";
import Muibook from "../../../img/casestudy/design-systems/muibook-theme-brand.png";
import MuibookUIKit from "../../../img/casestudy/design-systems/guidelines.png";
import BoneCarving from "../../../img/bonecarving.png";
import Redactd from "../../../img/redactd.png";

const VisibleOnDesktop = css`
  display: none;
  @media (min-width: 1250px) {
    display: block;
  }
`;

const ImageWrapper = styled.div`
  margin-bottom: 48px;
`;

const VisibleOnTablet = css`
  display: none;
  @media (min-width: 600px) {
    display: block;
  }
`;

const LeftAligned = styled.div`
  text-align: left;
  margin-bottom: var(--spacing-clear);
`;

const List = styled.li`
  font-size: var(--font-size-text-small);
  &:last-child {
    margin-bottom: 0;
  }
`;

const CaseStudiesContainer = styled(Container)`
  max-width: 124rem;
  width: 100%;
  padding-top: var(--spacing-clear);
  @media (min-width: 1024px) {
    padding-top: var(--spacing-x-large);
    padding-bottom: var(--spacing-clear);
  }
`;

const ScrollToSection = styled.div`
  margin-bottom: var(--spacing-x-large);
`;

const Grid = styled.div`
  padding: var(--spacing-large);
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 160px 1fr;
    grid-gap: var(--spacing-x-large);
    padding: var(--spacing-large);
    padding-top: var(--spacing-small);
    margin-bottom: var(--spacing-clear);
  }
`;

const Message = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: var(--spacing-small);
  background: rgba(0 0 0 / 0.2);
  display: flex;
  gap: var(--spacing-x-small);
  p {
    margin: 0;
    font-size: var(--font-size-text-small);
  }
`;

const Aside = styled.aside`
  display: none;
  @media (min-width: 1024px) {
    display: block;
  }
  padding-top: var(--spacing-x-large);
  text-align: left;
  a {
    display: block;
    margin-bottom: var(--spacing-small);
  }
`;

const AsideSticky = styled.div`
  position: sticky;
  top: var(--spacing-x-medium);
`;

const BlogSectionVerticalSpace = styled.section`
  margin-bottom: var(--spacing-clear);
`;

const StyledLinkButton = styled.a`
  color: #ff73df;
  text-decoration: none;
  &:hover,
  &:focus {
    color: #ff89e4;
  }
`;

const ResumeProfileInfo = styled.div`
  @media (min-width: 600px) {
    margin-bottom: var(--flx-spacing-clear);
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    column-gap: var(--spacing-x-large);
  }
`;

const ResumeProfile = styled.div`
  margin: 0;
  margin-bottom: var(--spacing-medium);
  @media (min-width: 1250px) {
    align-items: start;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 4.8rem;
    padding-top: var(--spacing-clear);
    align-items: start;
  }
`;

const ProfileImage = css`
  width: 20rem;
  border-radius: 100%;
  overflow: hidden;
  box-shadow: 0 0 0 0.8rem #3b3b39;
  img {
    width: 100%;
    height: auto;
    min-height: 20rem;
  }
  ${(props) =>
    props.small &&
    css`
      width: 12rem;
      img {
        min-height: 12rem;
      }
    `}
`;

const PrimaryProfileImage = styled.div`
  ${ProfileImage}
  margin: 0 auto var(--spacing-x-large);
  @media (min-width: 600px) {
    display: none;
  }
  @media (min-width: 1250px) {
    display: block;
  }
`;

const SecondaryProfileImage = styled.div`
  ${ProfileImage}
  display: none;
  @media (min-width: 600px) {
    display: block;
    margin: 0 auto;
    margin-bottom: var(--spacing-medium);
  }
  @media (min-width: 1250px) {
    display: none;
  }
`;

const Contact = styled.div`
  display: flex;
  margin: 0;
  margin-top: var(--spacing-large);
  a {
    color: white;
    border-color: rgba(255, 255, 255, 0.2);
    &:hover {
      color: #ff73df;
    }
  }
  p {
    margin: 0;
  }
  p,
  h5 {
    text-align: center;
  }
  @media (min-width: 600px) {
    display: block;
    margin-top: var(--spacing-clear);
  }
  @media (min-width: 1250px) {
    p,
    h5 {
      text-align: right;
    }
  }
`;

const ContactTitle = styled.h5`
  ${VisibleOnDesktop}
  color: #ff73df;
  margin: var(--spacing-clear);
  margin-bottom: var(--spacing-tiny);
`;

const ContactLocation = styled.div`
  margin-bottom: var(--spacing-clear);
  display: none;
  @media (min-width: 600px) {
    margin-top: var(--spacing-small);
    display: block;
  }
  @media (min-width: 1250px) {
    margin-top: var(--spacing-large);
  }
  p:last-child {
    ${VisibleOnTablet}
  }
`;

const GridContent = styled.div`
  @media (min-width: 1300px) {
    display: grid;
    grid-template-columns: 1fr 340px;
    column-gap: 48px;
    margin-bottom: var(--spacing-clear);
  }
`;

const Introduction = styled.div`
  margin-bottom: 0;
  h3,
  p {
    text-align: center;
  }
  @media (min-width: 600px) {
    h3,
    p {
      text-align: left;
    }
    p {
      max-width: 57ch;
      font-family: var(--font-family);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const PrimaryContent = styled.div`
  margin-bottom: var(--spacing-clear);
`;

const SourcedPrimaryCard = styled(CaseStudiesCard)`
  padding-bottom: var(--spacing-medium);
`;

const EducationCard = styled(CaseStudiesCard)`
  margin-bottom: var(--spacing-clear);
`;

const EducationCardTitle = styled.h2`
  @media (min-width: 1300px) {
    font-size: var(--font-size-heading-medium);
  }
`;

const EducationTitle = styled.h6`
  margin: var(--spacing-clear);
`;

const EducationTitleSpace = styled.div`
  height: var(--spacing-xx-tiny);
  margin: var(--spacing-clear);
`;

const ResumeTitle = styled.p`
  margin-top: var(--spacing-clear);
  color: white !important;
  margin-bottom: var(--spacing-clear);
`;

const EducationDate = styled.p`
  margin-top: var(--spacing-clear);
  margin-bottom: var(--spacing-clear);
`;

const EducationPosition = styled.p`
  margin-top: var(--spacing-clear);
  margin-bottom: var(--spacing-small);
  opacity: 0.6;
`;

const SkillGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
`;

const Sourced = styled.p`
  text-align: center;
  margin: var(--spacing-clear);
`;

const SkillsHeading = styled.h2``;

const SkillsIntroduction = styled.p`
  margin-bottom: var(--spacing-large);
`;

const LocalGrid = styled.div`
  display: grid;
  column-gap: var(--spacing-large);
  row-gap: var(--spacing-clear);
  grid-template-columns: 1fr;
  @media (min-width: 600px) {
    column-gap: var(--spacing-large);
    row-gap: var(--spacing-tiny);
    grid-template-columns: 1fr 1fr;
  }
  ul:not(:last-child) {
    margin-bottom: var(--spacing-clear);
  }
  ul:last-child li:last-child {
    margin-bottom: var(--spacing-clear);
  }
`;

const LocalGridList = styled.ul`
  display: grid;
  row-gap: var(--spacing-clear);
  grid-template-columns: 1fr;
  @media (min-width: 600px) {
    column-gap: var(--spacing-x-large);
    row-gap: var(--spacing-tiny);
    grid-template-columns: 1fr 1fr;
  }
  li:last-child {
    margin-bottom: 0;
  }
`;

const SkillsInner = styled.div`
  margin-top: var(--spacing-large);
  margin-bottom: var(--spacing-x-large);
  &:last-of-type {
    margin-bottom: var(--spacing-large);
  }
`;

const ProjectsList = styled.ul`
  margin-bottom: var(--spacing-x-medium);
`;

const ProjectsHeadingWrapper = styled.div`
  margin-top: var(--spacing-x-large);
  display: flex;
  align-items: baseline;
  margin-bottom: ${(props) => (props.smallMargin ? "var(--spacing-tiny);" : "var(--spacing-medium)")};
`;

const ProjectsHeading = styled.h3`
  margin-bottom: var(--spacing-clear);
  flex: 0 0 auto;
  width: auto;
`;

const ProjectsSubHeading = styled.h3`
  margin-bottom: var(--spacing-clear);
  flex: 0 0 auto;
  width: auto;
  font-weight: normal;
  font-family: var(--font-family);
  color: #bfbfbf;
  span {
    padding: 0 var(--spacing-x-small) 0 var(--spacing-small);
    color: #404040;
  }
`;

const ProjectsParagraph = styled.p`
  margin-bottom: var(--spacing-large);
`;

const ProjectsUList = styled.ul`
  margin-bottom: var(--spacing-large);
`;

const VerticalSpace = styled.div`
  height: 4.8rem;
`;

const Resume = () => {
  return (
    <Grid>
      <Aside>
        <AsideSticky>
          <StyledLinkButton href="#introduction">Introduction</StyledLinkButton>
          <StyledLinkButton href="#capabilities">Capabilities</StyledLinkButton>
          <StyledLinkButton href="#projects">Projects</StyledLinkButton>
          <StyledLinkButton href="#blog">Blog</StyledLinkButton>
          <StyledLinkButton href="#interests">Interests</StyledLinkButton>
        </AsideSticky>
      </Aside>
      <CaseStudiesContainer large center>
        <LeftAligned>
          <BlogSectionVerticalSpace>
            <ScrollToSection id="introduction">
              <ResumeProfile>
                <PrimaryProfileImage>
                  <img alt="Michael Trilford Profile" src={DesignSystemsProfile} />
                </PrimaryProfileImage>
                <ResumeProfileInfo>
                  <Introduction>
                    <ResumeHeading title="Michael Trilford" />
                    <Heading variant="medium">Product Design, Design Systems & Technology</Heading>
                    <p>
                      Senior Product Designer with 18 years of experience across product design, UX, design systems, and
                      frontend technologies. Experienced in discovery, experimentation, prototyping, and delivery across
                      customer-facing products and platform teams, helping teams turn complex problems into scalable,
                      accessible experiences.
                    </p>
                  </Introduction>
                  <Contact>
                    <SecondaryProfileImage small>
                      <img alt="Michael Trilford Profile" src={DesignSystemsProfile} />
                    </SecondaryProfileImage>
                    <ContactTitle>Contact</ContactTitle>
                    <p style={{ marginBottom: 8 }}>
                      <Links rel="noopener noreferrer" href="mailto:trilfordm@gmail.com">
                        trilfordm@gmail.com
                      </Links>
                    </p>
                    <p style={{ marginBottom: 8 }}>
                      <Links rel="noopener noreferrer" href="tel:+61 434447445">
                        +61434447445
                      </Links>
                    </p>
                    <p style={{ marginBottom: 8 }}>
                      <span role="img" aria-label="PDF">
                        🖨️
                      </span>{" "}
                      <Links href="/resume.pdf" target="_blank" rel="noopener noreferrer">
                        Print resume
                      </Links>
                    </p>
                    <ContactLocation>
                      <ContactTitle>Location</ContactTitle>
                      <p>Melbourne, VIC</p>
                      <p>Australia</p>
                    </ContactLocation>
                  </Contact>
                </ResumeProfileInfo>
              </ResumeProfile>
            </ScrollToSection>
            <GridContent>
              <PrimaryContent>
                <ScrollToSection id="capabilities">
                  <SourcedPrimaryCard>
                    <Heading>Capabilities</Heading>
                    <Rule inverted />

                    <SkillsInner>
                      <SkillsHeading>Product Design</SkillsHeading>
                      <SkillsIntroduction>
                        I use discovery, experimentation, and prototyping to reduce uncertainty and help teams make
                        informed product decisions. My approach combines customer insight, business objectives, and
                        technical feasibility to identify opportunities, validate direction, and deliver measurable
                        outcomes.
                      </SkillsIntroduction>
                      <SkillGrid>
                        <SkillsItem
                          small
                          noTooltip
                          title="PRODUCT DESIGN"
                          icon="rgbaIcon"
                          description="Use discovery, experimentation, and prototyping to validate ideas and guide product decisions."
                        />
                        <SkillsItem
                          small
                          noTooltip
                          title="LEAN UX"
                          icon="uxIcon"
                          description="Facilitate discovery, testing, and validation to uncover opportunities, reduce risk, and guide product direction."
                        />
                        <SkillsItem
                          small
                          noTooltip
                          title="AI PROTOTYPING"
                          icon="aiIcon"
                          description="Leverage LLMs and agent-based workflows to accelerate exploration, prototyping, delivery, and iteration."
                        />
                        <SkillsItem
                          small
                          noTooltip
                          title="PRODUCT DELIVERY"
                          icon="agileIcon"
                          description="Collaborate across design, engineering, and product to deliver customer outcomes and measurable business value."
                        />
                      </SkillGrid>
                      <Heading variant="small" mt="var(--spacing-x-large)">
                        Skill Overview
                      </Heading>

                      <ul>
                        <List>
                          <strong style={{ color: "white" }}>Discovery & Customer Insight:</strong> Run user research,
                          interviews, and usability testing to uncover real needs and validate concepts early.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>Product Strategy & Opportunity Framing:</strong> Partner
                          with product managers to frame opportunities, define success metrics, and shape roadmap
                          direction.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>Prioritisation & Decision Making:</strong> Balance customer
                          needs, business goals, and technical constraints to identify opportunities and guide roadmap
                          direction.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>User Journeys & Workflow Mapping:</strong> Map end-to-end
                          user experiences and touchpoints to align teams, expose gaps, and design clean workflows.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>Rapid Prototyping & Experimentation:</strong> Build
                          interactive prototypes at the right fidelity to test hypotheses, gather feedback, and validate
                          product direction.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>AI-Assisted Workflows:</strong> Integrate LLMs and
                          agent-based design tools to accelerate exploration, iterate on interfaces, and optimise
                          execution velocity.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>Design System Contribution:</strong> Align product layouts
                          with centralised token structures and component libraries to maintain visual consistency.
                        </List>

                        <List>
                          <strong style={{ color: "white" }}>Front-End Collaboration:</strong> Bridge design and
                          engineering by understanding technical constraints, co-creating components, and collaborating
                          on code.
                        </List>
                      </ul>
                    </SkillsInner>

                    <Rule inverted />

                    <SkillsInner>
                      <SkillsHeading>Design Systems</SkillsHeading>
                      <SkillsIntroduction>
                        I craft reusable, composable, and scalable design systems. Working closely with designers and
                        developers, I align Figma and code from the start, embedding tokenisation, accessibility, and
                        flexibility. I treat design systems as products that reduce friction, drive adoption, and help
                        teams build faster. I'm focused on scaling these practices to enable teams to deliver impactful,
                        user-centered experiences with confidence.
                      </SkillsIntroduction>

                      <Heading variant="smaller">Expertise</Heading>

                      <LocalGridList>
                        <List>Prepared the design system for AI tooling and prompt-based prototyping</List>
                        <List>Aligned component strategy with atomic design principles and scalable foundations</List>
                        <List>Implemented and maintained design tokens and Figma UI Kits aligned with code</List>
                        <List>Defined governance, contribution models, and mentored teams to improve adoption</List>
                        <List>Led CSS architecture, responsive patterns, and reusable UI components</List>
                        <List>Developed usage guidelines, documentation, and tracked system health metrics</List>
                      </LocalGridList>

                      <Heading variant="smaller">Accessibility Experience</Heading>
                      <LocalGridList>
                        <List>
                          <strong style={{ color: "white" }}>Responsive design: </strong>Build device-agnostic,
                          composable interfaces and flexible components for consistent experiences across breakpoints
                        </List>
                        <List>
                          <strong style={{ color: "white" }}>Colour contrast: </strong>Ensure AA/AAA compliance through
                          regular review in design critiques and component audits
                        </List>
                        <List>
                          <strong style={{ color: "white" }}>Typography: </strong>Use legible, screen-optimised type
                          scales for accessibility and readability
                        </List>
                        <List>
                          <strong style={{ color: "white" }}>Dynamic UI: </strong>Design with user preferences in mind
                          using scalable units (REM) for zoom and text scaling support
                        </List>
                        <List>
                          <strong style={{ color: "white" }}>Screen readers support: </strong>Apply semantic HTML with
                          alt, aria, and role attributes to ensure compatibility from design through to code
                        </List>
                        <List>
                          <strong style={{ color: "white" }}>Keyboard accessibility: </strong>Enable full keyboard
                          navigation using aria and tabindex, including for custom or non-semantic components
                        </List>
                      </LocalGridList>
                      <Heading variant="small">Article</Heading>
                      <Message style={{ marginBottom: "var(--spacing-small)" }}>
                        {" "}
                        <span role="img" aria-label="Read more on Medium">
                          📖
                        </span>
                        <Stack disableMargin>
                          <Heading variant="smallest" mt="0" mb="0" color="white">
                            Muibook Accessibility Insights
                          </Heading>
                          <p>
                            Discover how accessibility principles are applied throughout Muibook to create inclusive,
                            responsive, and scalable design system components.{" "}
                            <Links href="/case-studies#muibook">Read more</Links>
                          </p>
                        </Stack>
                      </Message>
                    </SkillsInner>

                    <Rule inverted />

                    <SkillsInner>
                      <SkillsHeading>Technical Capability</SkillsHeading>
                      <SkillsIntroduction>
                        Understanding the medium is key to delivering high-quality user experiences. My front- end
                        background allows me to collaborate deeply with engineering teams, validate design feasibility,
                        and build robust prototyping environments.
                      </SkillsIntroduction>
                      <SkillGrid>
                        <SkillsItem
                          small
                          noTooltip
                          title="HTML"
                          icon="htmlIcon"
                          description="Create clean, semantic HTML structures that support accessibility and responsive layouts."
                        />

                        <SkillsItem
                          small
                          noTooltip
                          title="CSS"
                          icon="cssIcon"
                          description="Strong CSS foundations across responsive layouts, accessibility, and scalable UI patterns."
                        />
                        <SkillsItem
                          small
                          noTooltip
                          title="REACT"
                          icon="reactIcon"
                          description="Comfortable working within React component architectures and modern frontend workflows."
                        />

                        <SkillsItem
                          small
                          noTooltip
                          title="AI ASSISTANCE"
                          icon="aiIcon"
                          description="Leverage AI in development to accelerate layout exploration, automate workflows, and uplift technical delivery and impact."
                        />

                        <SkillsItem
                          small
                          noTooltip
                          title="WEB COMPONENTS"
                          tooltip="large"
                          icon="webComponentsIcon"
                          description="I craft accessible web components using native browser tech, making reusable and portable components across tech stacks."
                        />

                        <SkillsItem
                          small
                          noTooltip
                          title="XCODE"
                          icon="xcodeIcon"
                          description="Prototype native iOS layouts in Xcode, leveraging AI-assisted coding to rapidly explore mobile UI patterns."
                        />
                      </SkillGrid>
                    </SkillsInner>
                    <Rule inverted />
                    <Sourced>
                      Information sourced from <Links href="/skills">Skills</Links>
                    </Sourced>
                  </SourcedPrimaryCard>
                </ScrollToSection>

                <ScrollToSection id="projects">
                  <SourcedPrimaryCard>
                    <Heading>Project Highlights</Heading>
                    <Rule inverted />
                    <ProjectsHeadingWrapper smallMargin>
                      <ProjectsHeading>Redactd</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2026
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      I'm currently building Redactd™ in public, pairing with AI and applying my full skill set across
                      product strategy, UX, UI, design systems, and front-end engineering to ship a product I believe
                      in.
                    </p>
                    <p>
                      Build and compose real web layouts directly with Web Components. Design by hand on a pixel-perfect
                      canvas or generate layouts via prompts, then move fluidly between both modes. Redactd runs
                      entirely in the browser and supports importing Web Components via CDN with export to HTML or JSON.
                    </p>
                    <p>
                      The live app is{" "}
                      <Links href="https://redactd.xyz/" target="_blank" rel="noopener noreferrer">
                        redactd.xyz
                      </Links>
                      , and I have documented the build-in-public process and AI pairing workflow in{" "}
                      <Links
                        href="https://www.designsystemscollective.com/pair-programming-with-ai-61b0021d6bec?source=friends_link&sk=8c5ccadaea0c8a7a14d29058fd3d8f36"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Pair Programming with AI
                      </Links>
                      .
                    </p>
                    <ImageWrapper style={{ margin: 0 }}>
                      <Image
                        dark
                        src={Redactd}
                        alt="Design by hand on a pixel-perfect canvas or generate layouts via prompts"
                        caption="Design by hand on a pixel-perfect canvas or generate layouts via prompts"
                      />
                    </ImageWrapper>
                    <VerticalSpace />
                    <Rule inverted />
                    <ProjectsHeadingWrapper smallMargin>
                      <ProjectsHeading>Airwallex Design System</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2020 - 2023
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      As the Design System Lead at Airwallex, I drove the evolution and maintenance of our in-house
                      Design System, enabling seamless collaboration between design and engineering to ensure
                      consistency, efficiency, and scalability.
                    </p>
                    <Heading variant="smaller">Key Contributions</Heading>
                    <LocalGridList>
                      <List>
                        <strong>Strategic Planning:</strong> Played a pivotal role in strategic decision-making for the
                        Design System, prioritising tasks and aligning with quarterly product goals.
                      </List>

                      <List>
                        <strong>Maintenance of Services:</strong> Managed Storybook and aligned Figma UI Kit with the
                        live codebase for consistency across design and development.
                      </List>

                      <List>
                        <strong>Onboarding:</strong> Streamlined the onboarding process for new Product Designers,
                        providing comprehensive guidance on contribution processes, tooling, and best practices.
                      </List>

                      <List>
                        <strong>Documentation & Guidelines:</strong> Orchestrated collaborative efforts to enhance our
                        UX documentation. Refocused guidelines to meet evolving product requirements.
                      </List>

                      <List>
                        <strong>Code Reviews:</strong> Ensured high-quality contributions to the Frontend Component
                        Library through detailed reviews of coded components, focusing on design token usage and
                        composability.
                      </List>

                      <List>
                        <strong>Design System Council:</strong> Provided feedback on emerging patterns and components,
                        facilitated updates, and curated feedback for continuous improvement.
                      </List>

                      <List>
                        <strong>Components:</strong> Actively enhanced coded components with responsive updates for
                        optimal performance across devices. Maintained the Figma component UI Library, ensuring
                        accessible properties and easy prototyping with component variants.
                      </List>

                      <List>
                        <strong>Collaboration & Communication:</strong> Orchestrated effective communication between
                        designers and developers, promoting technical collaboration and efficient development processes.
                      </List>
                    </LocalGridList>
                    <Heading variant="smaller">Contribution Model</Heading>
                    <p>
                      My approach emphasised empowering teams to contribute effectively to the system, fostering
                      alignment across product teams.{" "}
                      <Links href="/case-studies#contribution" rel="noopener noreferrer">
                        Learn more
                      </Links>{" "}
                      about my approach with contribution models
                    </p>
                    <ImageWrapper>
                      <Image
                        dark
                        src={AirwallexContribution}
                        alt="Contribution model for Airwallex Design System"
                        caption="Contribution model (Airwallex Design System)"
                      />
                    </ImageWrapper>
                    <Heading variant="smaller" style={{ marginTop: 0 }}>
                      UIKit & UX Guidelines
                    </Heading>
                    <p>
                      To maintain consistency across products during the design exploration phases, we closely
                      integrated UX Guidelines within Figma, ensuring they were always accessible as designers
                      prototyped new experiences. This approach helped designers utilise common patterns across products
                      and avoid introducing multiple variations of similar approaches, aligning design intent with
                      development execution from the outset.
                    </p>
                    <ProjectsUList>
                      <List>
                        <Links
                          href="https://medium.com/@trilfordm/enabling-organisations-to-contribute-to-the-design-system-b3dc860b5a04"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Read more
                        </Links>{" "}
                        about my approach to collaboration.
                      </List>
                      <List>
                        <Links
                          href="https://medium.com/@trilfordm/how-to-create-high-quality-guidelines-for-your-design-system-library-6127b482c1e8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Learn more
                        </Links>{" "}
                        about how I created high-quality guidelines.
                      </List>
                    </ProjectsUList>
                    <ImageWrapper>
                      <Image
                        dark
                        src={Airwallex}
                        alt="Guidelines embedded within Figma workspaces"
                        caption="Guidelines embedded within Figma workspaces"
                      />
                    </ImageWrapper>
                    <p style={{ margin: 0 }}>
                      Throughout my tenure at Airwallex, I've fostered a collaborative Design System environment,
                      delivering robust, scalable, and user-friendly outcomes. I'm eager to leverage my experience to
                      drive design excellence in future opportunities.
                    </p>
                    <VerticalSpace />
                    <Rule inverted />
                    <ProjectsHeadingWrapper smallMargin>
                      <ProjectsHeading>Feelix Design System</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2018 - 2020
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      I contributed to the evolution of Feelix by shaping its documentation site, collaborating with
                      engineers to develop key components for the MYOB product experience, crafting design tokens, and
                      enhancing responsive design support through CSS contributions.
                    </p>
                    <ProjectsList>
                      <List>
                        <Links href="/case-studies#maturefeelix" rel="noopener noreferrer">
                          Maturing Feelix • <i>June 2018</i>
                        </Links>
                      </List>
                      <List>
                        <Links href="/case-studies#designsystems" rel="noopener noreferrer">
                          View all Design system case studies
                        </Links>
                      </List>
                    </ProjectsList>
                    <ImageWrapper>
                      <Image dark src={Feelix} alt="Feelix Design System" />
                    </ImageWrapper>
                    <Heading variant="smaller" mt="var(--spacing-x-large)">
                      Key Contributions
                    </Heading>
                    <LocalGrid style={{ margin: 0 }}>
                      <ul>
                        <List>Ensuring components follow atomic design principles</List>
                        <List>Restructure the design system to use scalable, modular CSS</List>
                        <List>Introduced responsive design across our components</List>
                        <List>Embedding a baseline grid for vertical rhythm</List>
                        <List>Defining a typographic scale with CSS</List>
                      </ul>
                      <ul>
                        <List>Designed the design token structure and naming convention</List>
                        <List>Leading the move to React layout components</List>
                        <List>Designing Feelix page templates and layout components</List>
                        <List>Expanding usage and technical guidelines</List>
                        <List>Explored automating the UI-Kit to reflect the Design System</List>
                      </ul>
                    </LocalGrid>
                    <VerticalSpace />
                    <Rule inverted />
                    <ProjectsHeadingWrapper smallMargin>
                      <ProjectsHeading>Muibook Design System</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2025
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      <Links href="https://muibook.com" target="_blank" rel="noopener noreferrer">
                        Muibook.com
                      </Links>{" "}
                      is the home of the MichaelUI Design System (MUI), a personal collection of Native Web Components
                      built for composability, performance and trusted customisation.
                    </p>
                    <ImageWrapper>
                      <Image
                        dark
                        src={Muibook}
                        alt="muibook.com – Resources, tokens, components, and implementation guides"
                        caption="muibook.com – Resources, tokens, components, and implementation guides"
                      />
                    </ImageWrapper>
                    <Heading variant="smaller">Why I Built This Design System</Heading>
                    <p>
                      I wanted a portfolio piece reflecting my vision of a complete, working design system. Design
                      systems span many touchpoints, from restricted Figma files to private Storybooks. Muibook shows a
                      full design system, not just UI components but the full experience: Figma components, code,
                      tokens, UX guidance, and AI integration.
                    </p>
                    <ProjectsList>
                      <List>
                        <Links href="https://muibook.com" target="_blank" rel="noopener noreferrer">
                          Muibook.com
                        </Links>
                      </List>
                      <List>
                        <Links
                          href="https://medium.com/@trilfordm/muibook-a-native-flexible-design-system-built-for-trusted-customisation-3e56c3e2f747"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Read the Blog
                        </Links>
                      </List>
                    </ProjectsList>
                    <ImageWrapper>
                      <Image
                        dark
                        src={MuibookUIKit}
                        alt="UI Kit & Contextual Guidelines"
                        caption="UI Kit & Contextual Guidelines"
                      />
                    </ImageWrapper>
                    <Heading variant="smaller" mt="var(--spacing-x-large)">
                      Goals
                    </Heading>
                    <LocalGrid style={{ margin: 0 }}>
                      <ul>
                        <List>
                          <strong>Keyboard Accessibility:</strong> Showcase how I handle accessibility across both
                          design and engineering, with live working examples of keyboard navigation.
                        </List>
                        <List>
                          <strong>Screen Reader Accessibility:</strong> Usage and understanding of ARIA and role
                          attributes are demonstrated through technical documentation and by reviewing the public code
                          repository on GitHub.
                        </List>
                        <List>
                          <strong>Multi-Brand & Theming:</strong> Demonstrate my approach to multi-brand and theming
                          (light/dark) experiences using CSS variables across platforms consistently.
                        </List>
                      </ul>
                      <ul>
                        <List>
                          <strong>Performance & Composability:</strong> How I build for performance and composability to
                          ensure a flexible system ready for human and AI adoption when building product.
                        </List>
                        <List>
                          <strong>AI-Ready Design System:</strong> How I see AI shaping the future of design systems by
                          exposing prompts and keywords through the system’s NPM package.
                        </List>
                      </ul>
                    </LocalGrid>
                    <VerticalSpace />
                    <Rule inverted />
                    <ProjectsHeadingWrapper smallMargin>
                      <ProjectsHeading>Design Sprint: Rural Accounting</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2017
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      In this design sprint, the cross-collaborative group looked to solve known and unknown problems
                      within the Accounting rural space.
                    </p>
                    <ProjectsList>
                      <List>
                        <Links href="/case-studies#designsprint" rel="noopener noreferrer">
                          Design sprint case study • <i>July 2017</i>
                        </Links>
                      </List>
                      <List>
                        <Links href="/case-studies#storytelling" rel="noopener noreferrer">
                          Storytelling case study • <i>July 2017</i>
                        </Links>
                      </List>
                    </ProjectsList>
                    <ImageWrapper>
                      <Image
                        dark
                        src={JourneyMap}
                        alt="Journey Map Workshop"
                        caption="Co-created journey map session."
                      />
                    </ImageWrapper>
                    <ImageWrapper>
                      <Image
                        dark
                        src={FinalJourneyMap}
                        alt="Final Journey Map"
                        caption="Journey map: From post-its to an A0 poster so the team can align."
                      />
                    </ImageWrapper>
                    <Rule inverted />
                    <ProjectsHeadingWrapper>
                      <ProjectsHeading>Guru Guides</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2025
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <ProjectsParagraph>
                      Guru Guides is a free tool that helps teams document and share design system guidelines directly
                      in Figma. It’s designed to increase engagement during the design process by reducing context
                      switching and keeping guidance close at hand, so designers can stay focused and maintain
                      consistency as teams scale.
                    </ProjectsParagraph>
                    <ProjectsList>
                      <List>
                        <Links href="/case-studies#guidelines" rel="noopener noreferrer">
                          Guidelines at Your Fingertips • <i>Apr 2025</i>
                        </Links>
                      </List>
                      <List>
                        <Links
                          href="https://www.figma.com/community/plugin/1471341082690554711"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Install Plugin
                        </Links>
                      </List>
                      <List>
                        <Links href="https://guides.gurusuite.xyz" target="_blank" rel="noopener noreferrer">
                          View Website
                        </Links>
                      </List>
                    </ProjectsList>
                    <Heading variant="smaller" mt="var(--spacing-x-large)">
                      Figma Plugin
                    </Heading>
                    <ProjectsParagraph>
                      This is the default Guru Guides Figma Plugin showing a collection of components with guideline
                      examples. The plugin can be customised to show specific components and guidelines relevant to your
                      design system.
                    </ProjectsParagraph>
                    <ImageWrapper>
                      <Image
                        dark
                        src={GuruGuidesD}
                        alt="Guru Guides: Figma Plugin"
                        caption="Guru Guides: Figma Plugin"
                      />
                    </ImageWrapper>
                    <ImageWrapper>
                      <Image
                        dark
                        src={GuruGuidesC}
                        alt="Feelix Org Guidelines (Figma Plugin)"
                        caption="Feelix Org Guidelines (Figma Plugin)"
                      />
                    </ImageWrapper>
                    <Heading variant="smaller" mt="var(--spacing-x-large)">
                      Website
                    </Heading>
                    <ProjectsParagraph>
                      The tool is also available via the web, ensuring guidelines are accessible to all team members,
                      regardless of their role or access to design tools. This inclusivity helps foster a shared
                      understanding of design principles across the entire team, from designers to product managers and
                      developers.
                    </ProjectsParagraph>
                    <ImageWrapper>
                      <Image
                        dark
                        src={GuruGuidesW}
                        alt="Muibook Org Guidelines (Website)"
                        caption="Muibook Org Guidelines (Website)"
                      />
                    </ImageWrapper>
                    <Rule inverted />
                    <ProjectsHeadingWrapper>
                      <ProjectsHeading>Guru Outcomes</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2025
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <ProjectsParagraph>
                      Outcomes is an app that helps users track objectives and key results in an outcome-based roadmap
                      format. It organises tasks into Upcoming, Doing, and Finished columns and includes tracking for
                      key results for each objective.
                    </ProjectsParagraph>
                    <ProjectsList>
                      <List>
                        <Links href="/case-studies#outcomes" rel="noopener noreferrer">
                          Improving Performance in Guru Outcomes • <i>Apr 2025</i>
                        </Links>
                      </List>
                      <List>
                        <Links href="https://outcomes.gurusuite.xyz" target="_blank" rel="noopener noreferrer">
                          outcomes.gurusuite.xyz
                        </Links>
                      </List>
                    </ProjectsList>
                    <ImageWrapper>
                      <Image dark src={GuruOutcomes} alt="Guru Outcomes: Web-App" caption="Guru Outcomes: Web-App" />
                    </ImageWrapper>
                    <Rule inverted />
                    <ProjectsHeadingWrapper>
                      <ProjectsHeading>Mobile Banking</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2017
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <ProjectsParagraph>
                      When running a small business, there are some tasks a business owner is required to do, which
                      helps with their tax compliance tasks. One of these tasks is reconciling their expenses to their
                      bank transactions that come into their accounting system. To ensure the experience is an enjoyable
                      and most efficient, the experience is designed to be less of a data-entry task, and more of a
                      simple review.
                    </ProjectsParagraph>
                    <ImageWrapper>
                      <Image dark src={MobileBanking} alt="Reconciling expenses" />
                    </ImageWrapper>
                    <Rule inverted />
                    <ProjectsHeadingWrapper>
                      <ProjectsHeading>Capture</ProjectsHeading>
                      <ProjectsSubHeading>
                        <span>|</span> 2017
                      </ProjectsSubHeading>
                    </ProjectsHeadingWrapper>
                    <p>
                      During an MYOB Hackday in 2017, I set out to investigate and create a solution for a
                      well-requested feature.
                    </p>
                    <p>
                      The capture experience allows business owners to record and store their business-related expenses
                      in a convenient and accessible digital format. By having this document available in the MYOB, the
                      system enables their accountant to have access to all the information they need for the tax
                      period.
                    </p>
                    <ProjectsParagraph>
                      Fast forward a few years to 2019, MYOB launched an application called MYOB Capture, that's right,
                      Capture. Where I wasn't involved in this project directly, a lot of the original thinking for the
                      experience remains core to the experience, such as capturing an image of the receipt and uploading
                      to an existing storage facility within the MYOB products, called In-tray.
                    </ProjectsParagraph>
                    <ImageWrapper>
                      <Image dark src={Capture} alt="Expense capture app" />
                    </ImageWrapper>
                    <Rule inverted mt="var(--spacing-large)" />
                    <Sourced>
                      Information sourced from <Links href="/">Home</Links> and{" "}
                      <Links href="/case-studies">Case studies</Links>.
                    </Sourced>
                  </SourcedPrimaryCard>
                </ScrollToSection>

                <ScrollToSection id="blog">
                  <SourcedPrimaryCard>
                    <Heading>Blog Posts</Heading>
                    <Rule inverted />
                    <ProjectsParagraph>
                      I write about my experiences, insights, and lessons learned in product design, UX, and design
                      systems. My blog serves as a platform to share knowledge, reflect on industry trends, and connect
                      with the broader design community.
                    </ProjectsParagraph>
                    <Stack disableMargin>
                      <ul style={{ marginBottom: "var(--spacing-clear)" }}>
                        <List>
                          <Links
                            href="https://www.designsystemscollective.com/pair-programming-with-ai-61b0021d6bec?source=friends_link&sk=8c5ccadaea0c8a7a14d29058fd3d8f36"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Pair Programming with AI • <i>Feb 2026</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/25edc4f48528"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Role-Aware Org Agent • <i>Sep 2025</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/guidelines-at-your-fingertips-848bdaeee0ee"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Guidelines at Your Fingertips • <i>Apr 2025</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/what-does-scaling-a-design-system-mean-to-you-18d01db92ddd"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            What Does Scaling a Design System Mean to You? • <i>Mar 2025</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/the-future-of-design-systems-with-ai-c04533756d89"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            The Future of Design Systems with AI • <i>Mar 2025</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/enabling-organisations-to-contribute-to-the-design-system-b3dc860b5a04"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Enabling Organisations to Contribute to the Design System • <i>Feb 2025</i>
                          </Links>
                        </List>

                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/crafting-adaptive-layouts-using-responsive-61b1b7b08d32"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Crafting adaptive layouts using a responsive component • <i>Dec 2024</i>
                          </Links>
                        </List>
                        <List>
                          <Links
                            href="https://medium.com/@trilfordm/how-to-create-high-quality-guidelines-for-your-design-system-library-6127b482c1e8"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Creating high quality guidelines • <i>Mar 2023</i>
                          </Links>
                        </List>
                        <List>
                          <Links
                            href="https://uxdesign.cc/improve-relationships-between-product-design-and-development-6ff67d93c987?source=friends_link&sk=7ebf62323b4acfca1076b7cbf461f5d8"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Improve relationships between design &amp; development • <i>May 2020</i>
                          </Links>
                        </List>
                        <List>
                          <Links href="/case-studies#roadmap" rel="noopener noreferrer">
                            Design System Product Discovery • <i>June 2018</i>
                          </Links>
                        </List>
                      </ul>
                    </Stack>
                  </SourcedPrimaryCard>
                </ScrollToSection>

                <ScrollToSection id="interests">
                  <SourcedPrimaryCard>
                    <Heading>Interests</Heading>
                    <Rule inverted />
                    <p>
                      When I’m not thinking about Design Systems, I enjoy general exercise, bone carving, and more
                      recently, traveling to Japan to embrace the culture and learn the language naturally.
                      Pronunciation comes a little easier since I grew up in New Zealand, where we learned Māori in
                      school. The similar vowel sounds help me find my footing in Japanese.
                    </p>
                    <p>
                      Growing up, I was lucky to have a father with a well-organised workshop filled with tools for
                      model making, furniture building, and creative projects. That early exposure sparked a lasting
                      interest in craft and making.
                    </p>
                    <SkillsHeading style={{ marginTop: 48 }}>Bone Carving</SkillsHeading>
                    <p>
                      Since 1989, I’ve been fascinated by a book called Bone Carving, which featured intricate designs,
                      particularly the main piece on its cover. Over the years, from intermediate school through to high
                      school and later in life, I’ve continued carving and improving my technique.
                    </p>
                    <ImageWrapper>
                      <Image dark src={BoneCarving} alt="Bone carving progress over the years" />
                    </ImageWrapper>
                    <p>
                      My most recent carving, completed over a Christmas break in 2018, represents the culmination of
                      everything I’ve learned. From sourcing and preparing the bone, sketching the design, to the slow
                      work of cutting, filing, and sanding, each step requires patience and care. The final detail,
                      creating the neck loop, became an exercise in precision and simplicity. It remains my best work so
                      far.
                    </p>
                    <SkillsHeading style={{ marginTop: 48 }}>Woodturning</SkillsHeading>
                    <p>
                      Alongside bone carving, I have spent time working with a wood lathe, creating bowls, vases, and
                      other sculptural forms. There is something deeply satisfying about starting with a rough block of
                      timber and gradually shaping it into a balanced and refined piece. The process requires focus,
                      rhythm, and attention to material.
                    </p>
                    <p style={{ marginBottom: 48 }}>
                      Each project teaches me something new about proportion and restraint. Whether working with bone or
                      wood, these crafts remind me that real progress comes through process, and that thoughtful design
                      in any form takes both patience and intention.
                    </p>
                    {/*
                    <ImageWrapper>
                      <Image dark src={WoodTurning} alt="Guru Outcomes: Web-App" caption="Guru Outcomes: Web-App" />
                    </ImageWrapper>
                    */}
                  </SourcedPrimaryCard>
                </ScrollToSection>
              </PrimaryContent>

              <Stack spacing="var(--spacing-large)">
                <EducationCard style={{ paddingBottom: "4rem" }}>
                  <EducationCardTitle>Resumes</EducationCardTitle>
                  <Box style={{ marginBottom: "var(--spacing-small)", display: "flex", alignItems: "" }}>
                    <ResumeTitle>Product Designer</ResumeTitle>
                    <Links
                      href="/resume-product-design.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#bfbfbf",
                        borderColor: "#bfbfbf5a",
                        fontSize: "var(--font-size-text-small)",
                      }}
                    >
                      Download
                    </Links>
                  </Box>
                  <Box style={{ marginBottom: "var(--spacing-small)", display: "flex", alignItems: "" }}>
                    <ResumeTitle>Design Technologist</ResumeTitle>
                    <Links
                      href="/resume-design-technologist.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#bfbfbf",
                        borderColor: "#bfbfbf5a",
                        fontSize: "var(--font-size-text-small)",
                      }}
                    >
                      Download
                    </Links>
                  </Box>
                  <Box style={{ marginBottom: 0, display: "flex", alignItems: "" }}>
                    <ResumeTitle>Design Systems</ResumeTitle>
                    <Links
                      href="/resume-design-system.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#bfbfbf",
                        borderColor: "#bfbfbf5a",
                        fontSize: "var(--font-size-text-small)",
                      }}
                    >
                      Download
                    </Links>
                  </Box>
                </EducationCard>

                <EducationCard>
                  <EducationCardTitle>Career</EducationCardTitle>
                  <EducationTitle>Boost</EducationTitle>
                  <EducationDate>Nov 2006 - Aug 2012</EducationDate>
                  <EducationPosition>Web Designer</EducationPosition>
                  <EducationTitleSpace />
                  <EducationDate>Aug 2012 - Oct 2015</EducationDate>
                  <EducationPosition>Front-end Designer</EducationPosition>
                  <Rule inverted />
                  <EducationTitle>MYOB</EducationTitle>
                  <EducationDate>Oct 2015 - Feb 2018</EducationDate>
                  <EducationPosition>Product Designer</EducationPosition>
                  <EducationTitleSpace />
                  <EducationDate>Feb 2018 - Mar 2018</EducationDate>
                  <EducationPosition>Senior Product Designer</EducationPosition>
                  <EducationTitleSpace />
                  <EducationDate>Mar 2018 - Nov 2020</EducationDate>
                  <EducationPosition>
                    Senior Product Designer <br /> (Design System)
                  </EducationPosition>
                  <Rule inverted />
                  <EducationTitle>Airwallex</EducationTitle>
                  <EducationDate>Nov 2020 - Oct 2023</EducationDate>
                  <EducationPosition>Design System Lead </EducationPosition>
                  <Rule inverted />
                  <EducationTitle>Career Break</EducationTitle>
                  <EducationDate>Oct 2023 - Jun 2024</EducationDate>
                  <EducationPosition>Travel</EducationPosition>
                  <Rule inverted />
                  <EducationTitle>GuruSuite.xyz</EducationTitle>
                  <EducationDate>Jun 2024 - Aug 2025</EducationDate>
                  <EducationPosition style={{ marginBottom: 0 }}>Founder • Designer • Engineer</EducationPosition>
                  <Box style={{ marginBottom: "var(--spacing-small)" }}>
                    <Links
                      target="_blank"
                      style={{
                        color: "#bfbfbf",
                        borderColor: "#bfbfbf",
                        fontSize: "var(--font-size-text-small)",
                      }}
                      href="https://medium.com/@trilfordm/guidelines-at-your-fingertips-848bdaeee0ee"
                    >
                      Read blog
                    </Links>
                  </Box>
                  <Rule inverted />
                  <EducationTitle>Muibook</EducationTitle>
                  <EducationDate>Jan 2025 - Jul 2025</EducationDate>
                  <EducationPosition style={{ marginBottom: 0 }}>Founder • Designer • Engineer</EducationPosition>
                  <Box style={{ marginBottom: "var(--spacing-small)" }}>
                    <Links
                      style={{
                        color: "#bfbfbf",
                        borderColor: "#bfbfbf",
                        fontSize: "var(--font-size-text-small)",
                      }}
                      href="/case-studies#muibook"
                    >
                      Read blog
                    </Links>
                  </Box>
                  <Rule inverted />

                  <Links
                    target="_blank"
                    style={{ fontSize: "var(--font-size-text-small)" }}
                    href="https://www.linkedin.com/in/michael-trilford-5a083114/"
                  >
                    See more on LinkedIn
                  </Links>
                </EducationCard>

                <EducationCard>
                  <EducationCardTitle>Education</EducationCardTitle>
                  <EducationTitle>Bachelor of Design</EducationTitle>
                  <EducationDate>Massey • 2002 – 2006</EducationDate>
                </EducationCard>

                <EducationCard>
                  <EducationCardTitle style={{ maxWidth: 10 }}>Workshops Attended</EducationCardTitle>
                  <EducationTitle>Lean UX</EducationTitle>
                  <EducationPosition>By Jeff Gothelf • 2013</EducationPosition>
                  <EducationTitle>Atomic Design</EducationTitle>
                  <EducationPosition>By Brad Frost • 2015</EducationPosition>
                  <EducationTitle>Mapping experiences</EducationTitle>
                  <EducationPosition>By James Kalbach • 2016</EducationPosition>
                </EducationCard>
              </Stack>
            </GridContent>
          </BlogSectionVerticalSpace>
        </LeftAligned>
      </CaseStudiesContainer>
    </Grid>
  );
};

export default Resume;
